import type { ReactNode } from "react";

export type ModuleId =
  | "chat"
  | "email"
  | "drive"
  | "people"
  | "calendar"
  | "docs"
  | "assistant";

export interface GlobalSearchResult {
  id: string;
  moduleId: ModuleId;
  title: string;
  subtitle?: string;
  timestamp?: string;
  href: string;
  icon?: ReactNode;
}

export type ModuleSearchState = "loading" | "ok" | "error";

export interface ModuleSearchResult {
  moduleId: ModuleId;
  label: string;
  state: ModuleSearchState;
  results: GlobalSearchResult[];
  error?: { message: string };
  refetch: () => void;
}

export interface ModuleSearchAdapter {
  moduleId: ModuleId;
  label: string;
  search: (q: string, signal: AbortSignal) => Promise<GlobalSearchResult[]>;
}

export const MODULE_ORDER: ModuleId[] = [
  "email",
  "chat",
  "calendar",
  "drive",
  "docs",
  "people",
  "assistant",
];
